<template>
  <OuterCasing :isScroll="isScroll">
    <LoadingComponents />
    <keep-alive include="lucky-elephant,daily-rewards">
      <router-view></router-view>
    </keep-alive>
  </OuterCasing>
</template>

<script>
import OuterCasing from "$common/components/outer-casing";
import LoadingComponents from '$superAppUser/components/loading-components';
import WechatJssdk from '$common/utils/wechat/web-jssdk';

export default {
  components: {
    OuterCasing,
    LoadingComponents
  },
  created() {
    WechatJssdk.config()?.then(res => WechatJssdk?.share())?.catch(err => {
      console.log('WechatJssdk err: ', err)
    });
  },
  mounted() {
  },
  data() {
    return {
      isScroll: false,
      scrollNames: []
    }
  },
  watch: {
    $route(val) {
      this.isScroll = !!(this.$root.getIosVersion && this.$root.getIosVersion.length && this.$root.getIosVersion[0] < 12 && this.scrollNames.indexOf(val.name) !== -1);
    }
  }
};
</script>
<style lang="stylus"></style>
